export default "__VITE_ASSET__nw9T6wnF__"